import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "role-multi-select",
  "data-testid": "role-multi-select"
}
const _hoisted_2 = ["id", "checked", "disabled", "data-testid", "onChange"]
const _hoisted_3 = ["for"]
const _hoisted_4 = {
  key: 0,
  class: "text-muted"
}


export default {
  __name: 'RoleMultiSelect',
  props: {
	roles: { type: Array, default: () => [] },
	modelValue: { type: Array, default: () => [] },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const toggle = (roleId, checked) => {
	const next = checked
		? [...props.modelValue, roleId]
		: props.modelValue.filter((id) => id !== roleId);
	emit("update:modelValue", next);
};

const ldapGroupCn = (ldapId) => ldapId.match(/^cn=([^,]+)/i)?.[1] ?? ldapId;

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.roles, (role) => {
      return (_openBlock(), _createElementBlock("div", {
        key: role.id,
        class: "form-check"
      }, [
        _createElementVNode("input", {
          id: `role-${role.id}`,
          class: "form-check-input",
          type: "checkbox",
          checked: __props.modelValue.includes(role.id),
          disabled: role.ldapId !== null,
          "data-testid": `role-checkbox-${role.roleId}`,
          onChange: $event => (toggle(role.id, $event.target.checked))
        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_2),
        _createElementVNode("label", {
          class: "form-check-label",
          for: `role-${role.id}`
        }, [
          _createTextVNode(_toDisplayString(role.title) + " ", 1 /* TEXT */),
          (role.ldapId)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                _cache[0] || (_cache[0] = _createTextVNode("(LDAP-Gruppe ", -1 /* CACHED */)),
                _createElementVNode("code", null, _toDisplayString(ldapGroupCn(role.ldapId)), 1 /* TEXT */),
                _cache[1] || (_cache[1] = _createTextVNode(")", -1 /* CACHED */))
              ]))
            : _createCommentVNode("v-if", true)
        ], 8 /* PROPS */, _hoisted_3)
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}
}

}